const iconCache = {};

const LOCKER_ICON_KEY = "locker-icon";
const SELECTED_LOCKER_ICON_KEY = "selected-locker-icon";
const POSITION_ICON_KEY = "position-icon";

const getLockerIcon = (): H.map.Icon => {
  if (iconCache[LOCKER_ICON_KEY]) {
    return iconCache[LOCKER_ICON_KEY];
  }
  const lockerIcon = new H.map.Icon("/assets/images/map_locker.png", {
    size: { w: 50, h: 50 },
    anchor: { x: 25, y: 25 },
    crossOrigin: true,
  });
  iconCache[LOCKER_ICON_KEY] = lockerIcon;
  return lockerIcon;
};

const getSelectedLockerIcon = (): H.map.Icon => {
  if (iconCache[SELECTED_LOCKER_ICON_KEY]) {
    return iconCache[SELECTED_LOCKER_ICON_KEY];
  }
  const selectedLockerIcon = new H.map.Icon("/assets/images/map_locker_selected.png", {
    size: { w: 50, h: 50 },
    anchor: { x: 25, y: 25 },
    crossOrigin: true,
  });
  iconCache[SELECTED_LOCKER_ICON_KEY] = selectedLockerIcon;
  return selectedLockerIcon;
};

const getPositionIcon = (): H.map.Icon => {
  if (iconCache[POSITION_ICON_KEY]) {
    return iconCache[POSITION_ICON_KEY];
  }
  const icon = new H.map.Icon("/assets/images/location.png", {
    size: { w: 40, h: 58 },
    anchor: { x: 20, y: 58 },
    crossOrigin: true,
  });
  iconCache[POSITION_ICON_KEY] = icon;
  return icon;
};

export { getLockerIcon, getSelectedLockerIcon, getPositionIcon };
